// extracted by mini-css-extract-plugin
export default {"tag_pula":"_404_tag_pula__2+mRR","content":"_404_content__gBG0J","bounce":"_404_bounce__GMws8"};